export default __webpack_public_path__ + "static/media/stockExist.ba651256.svg";